module.exports = __webpack_public_path__ + "img/app_development.157f76c3.png";